import "./YearSelector.css";
export default function YearSelector({ value, onChange, earliestYear = new Date().getFullYear() - 1 }) {
  const current = new Date().getFullYear();
  const first = Math.min(current - 1, earliestYear);
  return <div className="reading-year-selector">
    <label>Reading year{' '}<select aria-label="Reading year" value={value} onChange={event => onChange(event.target.value)}>
      {Array.from({ length: current - first + 1 }, (_, index) => current - index).map(year => <option key={year} value={year}>{year}{year === current ? ' · This year' : ''}</option>)}
      <option value="all">All time</option>
    </select></label>
    <p>Each year starts fresh automatically. Past reading stays saved—choose a year to revisit it.</p>
  </div>;
}
